import React, { useState, useEffect, useRef } from 'react';
import '../scss/Emsmain.scss';
import Header from '../components/header'
import BaseURL from '../assets/contants/BaseURL';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import axios from 'axios';
import moment from 'moment';
import ExcelJS from 'exceljs';


const FlowReport = () => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("Hourly");
    const [hourlyfromdate, setHourlyfromdate] = useState(0);
    const [hourlytodate, setHourlytodate] = useState(0);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [hourlyloading, setHourlyLoading] = useState(false);
    const [hourlyData, setHourlyData] = useState([]);
    const [currenthourlyPage, setCurrenthourlyPage] = useState(1);
    const [totalLiters, setTotalLiters] = useState(0);
    const [dailyloading, setDailyLoading] = useState(false);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [totalDailyLiters, setTotalDailyLiters] = useState(0);
    const [monthlyloading, setMonthlyLoading] = useState(false);
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [monthlytoDate, setmonthlyToDate] = useState(null);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthsData, setMonthsData] = useState([]);
    const [reportData, setReportData] = useState(null);
    const [selectedMeter, setSelectedMeter] = useState("");
    const [selecteddailyMeter, setSelecteddailyMeter] = useState("");
    const [selectedmonMeter, setSelectedmonMeter] = useState("");
    const [allMeters, setAllMeters] = useState([]);
    const [filteredMeters, setFilteredMeters] = useState([]);
    const [filteredDailyMeter, setFilteredDailyMeter] = useState([]);
    const [filteredMonthlyMeter, setFilteredMonthlyMeter] = useState([]);
    const [searchMeter, setSearchMeter] = useState('');
    const [searchdailyMeter, setSearchdailyMeter] = useState('');
    const [searchmonthMeter, setSearchmonthMeter] = useState('');
    const [unitType, setUnitType] = useState('kilo');
    const [unitHourlyType, setUnitHourlyType] = useState('kilo');

    useEffect(() => {
            const fetchMeters = async () => {
                try {
                    const metersResponse = await axios.get(`${BaseURL}/meters/flowmeters/`);
                    const meters = metersResponse.data;
                    setAllMeters(meters);
                    setFilteredMeters(meters);
                    setFilteredMonthlyMeter(meters);
                    setFilteredDailyMeter(meters);
                } catch (error) {
                    console.error("Error fetching meter data:", error);
                }
            };
    
            fetchMeters();
        }, []);

    const tabs = ["Hourly", "Daily", "Monthly"];

    const handleTabChange = (tab) => {
        setActiveTab(tab);

        if (tab !== "Hourly") {
            setHourlyData([]);
            setHourlyfromdate(0);
            setHourlytodate(0);
            setCurrenthourlyPage(1);
            setTotalLiters(0);
            setSearchMeter("");
            setIsOpen(false);
        }
        if (tab !== "Daily") {
            setDailyreportData([]);
            setFromDate(0);
            setToDate(0);
            setCurrentdailyreportPage(1);
            setTotalDailyLiters(0);
            setSearchMeter("");
            setIsOpen(false);
        }
        if (tab !== "Monthly") {
            setMonthsData([]);
            setmonthlyFromDate(0);
            setmonthlyToDate(0);
            setCurrentmonthlyreportPage(1);
            setReportData(0);
            setSearchMeter("");
            setIsOpen(false);
        }
    };

    const handleSelect = (meterId, tab) => {
        switch (tab) {
            case 'Hourly':
                setSelectedMeter(meterId);
                break;
            case 'Daily':
                setSelecteddailyMeter(meterId);
                break;
            case 'Monthly':
                setSelectedmonMeter(meterId);
                break;
            default:
                break;
        }

        setIsOpen(false);
    };

    useEffect(() => {
            const filtered = allMeters.filter(meter =>
                meter.flow_meter_name.toLowerCase().includes(searchMeter.toLowerCase()) ||
                meter.flow_meter_id.toLowerCase().includes(searchMeter.toLowerCase())
            );
            setFilteredMeters(filtered);
        }, [searchMeter, allMeters]);
    
    
        useEffect(() => {
            const filtered = allMeters.filter(meter =>
                meter.flow_meter_name.toLowerCase().includes(searchdailyMeter.toLowerCase()) ||
                meter.flow_meter_id.toLowerCase().includes(searchdailyMeter.toLowerCase())
            );
            setFilteredDailyMeter(filtered);
        }, [searchdailyMeter, allMeters]);
    
    
        useEffect(() => {
            const filtered = allMeters.filter(meter =>
                meter.flow_meter_name.toLowerCase().includes(searchmonthMeter.toLowerCase()) ||
                meter.flow_meter_id.toLowerCase().includes(searchmonthMeter.toLowerCase())
            );
            setFilteredMonthlyMeter(filtered);
        }, [searchmonthMeter, allMeters]);


    useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setIsOpen(false);
                }
            };
    
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);

    const handleGetHourlyReport = async () => {
        if (!hourlyfromdate || !hourlytodate || !selectedMeter) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setHourlyLoading(true);
        try {
            const fromDate = moment(hourlyfromdate).format("YYYY-MM-DD");
            const fromTime = moment(hourlyfromdate).format("HH:mm");
            const toDate = moment(hourlytodate).format("YYYY-MM-DD");
            const toTime = moment(hourlytodate).format("HH:mm");

            const response = await axios.post(`${BaseURL}data/flow-hourly-report/`, {
                from_date: fromDate,
                to_date: toDate,
                from_time: fromTime,
                to_time: toTime,
                flowmeter_id: selectedMeter
            });

            if (response.data.results) {
                const transformedData = response.data.results.time_intervals.map((time, index) => ({
                    id: index,
                    date: response.data.results.date[index],
                    timeInterval: time,
                    startLiters: response.data.results.columns[0].data[index] || 0,
                    endLiters: response.data.results.columns[1].data[index] || 0,
                    totalLiters: response.data.results.columns[2].data[index] || 0
                }));
                const adjustedTotalLiters = transformedData.reduce(
                    (sum, row) => sum + (row.totalLiters || 0),
                    0
                );

                setHourlyData(transformedData);
                setTotalLiters(adjustedTotalLiters);
                setUnitHourlyType(response.data.unit_type);
            } else if (response.data.error) {
                alert(response.data.error);
                setHourlyData([]);
                setTotalLiters(0);
            }
        } catch (error) {
            console.error("Error fetching hourly report:", error);
            alert("Failed to fetch hourly report data");
            setHourlyData([]);
            setTotalLiters(0);
        } finally {
            setHourlyLoading(false);
        }
    };

    const formatDateForDisplay = (dateString) => {
        return moment(dateString).format("YYYY-MM-DD");
    };

    const rowsPerPage = 10;

    const totalhourlyPages = Math.ceil(hourlyData.length / rowsPerPage);

    const indexOfLastRow = currenthourlyPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = hourlyData.slice(indexOfFirstRow, indexOfLastRow);

    const handlehourlyPageChange = (newPage) => {
        setCurrenthourlyPage(newPage);
    };

    const handleGetDailyReport = async () => {
        if (!fromDate || !toDate || !selectedMeter) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setDailyLoading(true);
        try {
            const startDate = moment(fromDate).format("YYYY-MM-DD");
            const startTime = moment(fromDate).format("HH:mm");
            const endDate = moment(toDate).format("YYYY-MM-DD");
            const endTime = moment(toDate).format("HH:mm");

            const response = await axios.post(`${BaseURL}data/flow-daily-report/`, {
                start_date: startDate,
                end_date: endDate,
                from_time: startTime,
                to_time: endTime,
                flowmeter_id: selectedMeter
            });

            if (response.data.columns && response.data.columns.length > 0) {
                const transformedData = response.data.dates.map((date, index) => ({
                    id: index,
                    date: date,
                    timeRange: response.data.Times[index],
                    startLiters: response.data.columns[0].data[index],
                    endLiters: response.data.columns[1].data[index],
                    totalLiters: response.data.columns[2].data[index]
                }));

                const adjustedTotalLiters = transformedData.reduce(
                    (sum, row) => sum + (row.totalLiters || 0),
                    0
                );

                setDailyreportData(transformedData);
                setTotalDailyLiters(adjustedTotalLiters);
                setUnitType(response.data.unit_type);
            } else if (response.data.error) {
                alert(response.data.error);
                setDailyreportData([]);
                setTotalDailyLiters(0);
            }
        } catch (error) {
            console.error("Error fetching daily report:", error);
            alert("Failed to fetch daily report data");
            setDailyreportData([]);
            setTotalLiters(0);
        } finally {
            setDailyLoading(false);
        }
    };

    const rowsdailyPerPage = 10;
    const totaldailyPages = Math.ceil(dailyreportData.length / rowsdailyPerPage);
    const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
    const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
    const currentDailyRows = dailyreportData.slice(indexOfdailyFirstRow, indexOfdailyLastRow);

    const handledailyPageChange = (newPage) => {
        setCurrentdailyreportPage(newPage);
    };

    const fetchMonthlyReport = async () => {
        if (!monthlyfromDate || !monthlytoDate || !selectedMeter) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setMonthlyLoading(true);
        try {
            const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
            const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;

            const response = await axios.post(`${BaseURL}data/flow-monthly-report/`, {
                from_month_year: fromMonthYear,
                to_month_year: toMonthYear,
                flowmeter_id: selectedMeter
            });

            setReportData(response.data);

            const transformedData = response.data.months.map((month, index) => ({
                id: index + 1,
                month: month,
                startFlow: response.data.columns[0].data[index],
                endFlow: response.data.columns[1].data[index],
                totalFlow: response.data.columns[2].data[index]
            }));

            setMonthsData(transformedData);
        } catch (error) {
            console.error("Error fetching monthly report:", error);
            alert("Failed to fetch monthly report data");
        } finally {
            setMonthlyLoading(false);
        }
    };

    const rowsmonthlyPerPage = 10;
    const totalmonthlyPages = Math.ceil(monthsData.length / rowsmonthlyPerPage);
    const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
    const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
    const currentMonthlyRows = monthsData.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);

    const handlemonthlyPageChange = (newPage) => {
        setCurrentmonthlyreportPage(newPage);
    };

    const handleMonthlyFromMonthChange = (date) => {
        setmonthlyFromDate(date);
    };

    const handleMonthlyToMonthChange = (date) => {
        setmonthlyToDate(date);
    };

    const handleHourlyExportToExcel = async () => {
        const fromDateTime = new Date(hourlyfromdate);
        const toDateTime = new Date(hourlytodate);

        const formattedFromDate = fromDateTime.toISOString().split('T')[0];
        const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
        const formattedToDate = toDateTime.toISOString().split('T')[0];
        const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const fileName = `Hourly_Flow_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;

        if (!hourlyData || hourlyData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Hourly Flow Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        const dateRow = worksheet.addRow([`From: ${moment(hourlyfromdate).format("YYYY-MM-DD HH:mm")} To: ${moment(hourlytodate).format("YYYY-MM-DD HH:mm")}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const meterInfoRow = worksheet.addRow([
            `Flow Meter ID: ${selectedMeter}`,
            '',
            '',
            `Site: Coimbatore`
        ]);
        meterInfoRow.font = { bold: true };
        meterInfoRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['HOURLY FLOW REPORT']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['Date', 'Time Interval', 'Start Flow (Liters)', 'End Flow (Liters)', 'Total Flow (Liters)'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center' };
        });

        hourlyData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                row.date,
                row.timeInterval,
                row.startLiters,
                row.endLiters,
                row.totalLiters
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center' };
            });
        });

        const totalRow = worksheet.addRow([
            '', '', 'TOTAL', '', totalLiters
        ]);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        worksheet.columns = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 }
        ];

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleDailyExportToExcel = async () => {
        if (!fromDate || !toDate || !selectedMeter) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        if (!dailyreportData || dailyreportData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromDateTime = new Date(fromDate);
        const toDateTime = new Date(toDate);

        const formattedFromDate = fromDateTime.toISOString().split('T')[0];
        const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const formattedToDate = toDateTime.toISOString().split('T')[0];
        const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');

        const fileName = `Daily_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Daily Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 20;
        worksheet.getColumn(2).width = 20;
        worksheet.getColumn(3).width = 20;
        worksheet.getColumn(4).width = 20;
        worksheet.getColumn(5).width = 20;

        const dateRow = worksheet.addRow([`From Date: ${moment(fromDate).format("YYYY-MM-DD HH:mm")}, To Date: ${moment(toDate).format("YYYY-MM-DD HH:mm")}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const branchRow = worksheet.addRow(['Site: Coimbatore', '', ``, '', `Meter ID: ${selectedMeter}`]);
        branchRow.font = { bold: true, size: 12 };
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(3).alignment = { horizontal: 'center' };
        branchRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['Daily Report']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['Date', 'Time Range', 'Start Flow', 'End Flow', 'Total Flow'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        dailyreportData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                formatDateForDisplay(row.date),
                row.timeRange,
                row.startLiters,
                row.endLiters,
                row.totalLiters
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow(['', '', '', 'TOTAL', totalDailyLiters]);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleMonthlyExportToExcel = async () => {
        if (!monthlyfromDate || !monthlytoDate || !selectedMeter) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        if (!monthsData || monthsData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
        const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;

        const fileName = `Monthly_Report_${fromMonthYear}_to_${toMonthYear}.xlsx`;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Report');

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 5; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(5 / 2) - 1;

            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        worksheet.getColumn(1).width = 10;
        worksheet.getColumn(2).width = 20;
        worksheet.getColumn(3).width = 20;
        worksheet.getColumn(4).width = 20;
        worksheet.getColumn(5).width = 20;

        const dateRangeText = `From Month: ${monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })} to ${monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}`;
        const dateRow = worksheet.addRow([dateRangeText]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 5);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const branchRow = worksheet.addRow(['Site: Coimbatore', '', ``, '', `Meter ID: ${selectedMeter}`]);
        branchRow.font = { bold: true, size: 12 };
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(3).alignment = { horizontal: 'center' };
        branchRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow(['Monthly Report']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 5);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = ['S.No', 'Month', 'Start Flow', 'End Flow', 'Total Flow'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        monthsData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                row.id,
                row.month,
                row.startFlow.toFixed(2),
                row.endFlow.toFixed(2),
                row.totalFlow.toFixed(2)
            ]);

            dataRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        const totalRow = worksheet.addRow(['', '', '', 'TOTAL', reportData?.total_liter_all_months?.toFixed(2) || '0.00']);
        totalRow.font = { bold: true };
        totalRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFEB3B' },
            };
            cell.alignment = { horizontal: 'right' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const getBase64FromImageUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    return (
        <div className="dashboard-container">
            <Header title="WATER FLOW REPORT" />
            <div className="dashboard" style={{
                marginTop: '100px',
            }}>
                <div className="main-container">
                    <div className="nav-bar">
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                className={activeTab === tab ? "active" : ""}
                                onClick={() => handleTabChange(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    {activeTab === "Hourly" && (
                        <div className="hourly-report">
                            <div className="card controls-card">
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
                                    <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                                        <div style={{ flex: 1 }}>
                                            <div
                                                style={{
                                                    width: '95%',
                                                    padding: '8px',
                                                    borderRadius: '5px',
                                                    // border: '1px solid #ccc',
                                                    position: 'relative',
                                                    marginBottom: '10px'
                                                }}
                                            >
                                                <div ref={dropdownRef}>
                                                    <div
                                                        className="select-dropdown"
                                                        onClick={() => setIsOpen(!isOpen)}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <span>{selectedMeter ? filteredMeters.find(meter => meter.flow_meter_id === selectedMeter)?.flow_meter_name : "Select Meter"}</span>
                                                        <span style={{ fontSize: '13px' }}><i className="fa-solid fa-angle-down"></i></span>
                                                    </div>

                                                    {isOpen && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '110%',
                                                                left: 0,
                                                                right: 0,
                                                                backgroundColor: 'white',
                                                                borderRadius: '5px',
                                                                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                                                                zIndex: 10,
                                                                maxHeight: '330px',
                                                                overflowY: 'auto',
                                                                border: '1px solid #000',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #ccc',
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Meter ID"
                                                                    value={searchMeter}
                                                                    onChange={(e) => setSearchMeter(e.target.value)}
                                                                    style={{
                                                                        width: '95%',
                                                                        padding: '8px',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #ccc',
                                                                    }}
                                                                />
                                                            </div>
                                                            {filteredMeters.length > 0 ? (
                                                                filteredMeters.map((meter) => (
                                                                    <div
                                                                        key={meter.flow_meter_id}
                                                                        onClick={() => handleSelect(meter.flow_meter_id, 'Hourly')}
                                                                        style={{
                                                                            padding: '5px',
                                                                            cursor: 'pointer',
                                                                            textAlign: 'left',
                                                                            fontSize: '12px',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.target.style.backgroundColor = '#006ec5';
                                                                            e.target.style.color = 'white';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.target.style.backgroundColor = 'transparent';
                                                                            e.target.style.color = 'black';
                                                                        }}
                                                                    >
                                                                        {meter.flow_meter_id} - {meter.flow_meter_name}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ padding: '10px' }}>No results found</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Datetime
                                    value={hourlyfromdate ? new Date(hourlyfromdate) : null}
                                    onChange={(momentObj) => {
                                        if (momentObj.isValid()) {
                                            setHourlyfromdate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                        }
                                    }}
                                    inputProps={{
                                        placeholder: "Select From Date Time",
                                        style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                    }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm"
                                    closeOnSelect={false}
                                />

                                <Datetime
                                    value={hourlytodate ? new Date(hourlytodate) : null}
                                    onChange={(momentObj) => {
                                        if (momentObj.isValid()) {
                                            if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                momentObj.set({
                                                    hour: 23,
                                                    minute: 59
                                                });
                                            }
                                            setHourlytodate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                        }
                                    }}
                                    inputProps={{
                                        placeholder: "Select To Date Time",
                                        style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                    }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm"
                                    closeOnSelect={false}
                                />
                                <button onClick={handleGetHourlyReport}>Get Report</button>
                                <button onClick={() => handleHourlyExportToExcel('Hourly_Report.xlsx')}>
                                    <i className="excel-icon">📊</i> Excel
                                </button>
                            </div>
                            {hourlyloading ? (
                                <span className="spinner" />
                            ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Hourly Log View from {hourlyfromdate ? moment(hourlyfromdate).format("YYYY-MM-DD HH:mm") : "Selected from Date"}
                                        to {hourlytodate ? moment(hourlytodate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Hour</th>
                                                <th>Start Flow</th>
                                                <th>End Flow</th>
                                                <th>Total Flow</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {hourlyData.length > 0 ? (
                                                currentRows.map((row, index) => (
                                                    <tr key={row.id}>
                                                        <td>{formatDateForDisplay(row.date)}</td>
                                                        <td>{row.timeInterval}</td>
                                                        <td>{row.startLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.endLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.totalLiters?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}   {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{(totalLiters || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  {unitHourlyType === 'kilo' ? 'KL' : 'ML'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}

                            {hourlyData.length > 0 && (
                                <div className="pagination-controls">
                                    <button
                                        disabled={currenthourlyPage === 1}
                                        onClick={() => handlehourlyPageChange(currenthourlyPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span> {currenthourlyPage} of {totalhourlyPages}</span>
                                    <button
                                        disabled={currenthourlyPage === totalhourlyPages}
                                        onClick={() => handlehourlyPageChange(currenthourlyPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                    {activeTab === "Daily" && (
                        <div className="daily-report">
                            <div className="card controls-card">
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
                                    <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                                        <div style={{ flex: 1 }}>
                                            <div
                                                style={{
                                                    width: '95%',
                                                    padding: '8px',
                                                    borderRadius: '5px',
                                                    // border: '1px solid #ccc',
                                                    position: 'relative',
                                                    marginBottom: '10px'
                                                }}
                                            >
                                                <div ref={dropdownRef}>
                                                    <div
                                                        className="select-dropdown"
                                                        onClick={() => setIsOpen(!isOpen)}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <span>{selecteddailyMeter ? filteredDailyMeter.find(meter => meter.flow_meter_id === selecteddailyMeter)?.flow_meter_name : "Select Meter"}</span>
                                                        <span style={{ fontSize: '13px' }}><i className="fa-solid fa-angle-down"></i></span>
                                                    </div>

                                                    {isOpen && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '110%',
                                                                left: 0,
                                                                right: 0,
                                                                backgroundColor: 'white',
                                                                borderRadius: '5px',
                                                                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                                                                zIndex: 10,
                                                                maxHeight: '330px',
                                                                overflowY: 'auto',
                                                                border: '1px solid #000',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #ccc',
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Meter ID or Name"
                                                                    value={searchdailyMeter}
                                                                    onChange={(e) => setSearchdailyMeter(e.target.value)}
                                                                    style={{
                                                                        width: '95%',
                                                                        padding: '8px',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #ccc',
                                                                    }}
                                                                />
                                                            </div>
                                                            {filteredDailyMeter.length > 0 ? (
                                                                filteredDailyMeter.map((meter) => (
                                                                    <div
                                                                        key={meter.flow_meter_id}
                                                                        onClick={() => handleSelect(meter.flow_meter_id, 'Daily')}
                                                                        style={{
                                                                            padding: '5px',
                                                                            cursor: 'pointer',
                                                                            textAlign: 'left',
                                                                            fontSize: '12px',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.target.style.backgroundColor = '#006ec5';
                                                                            e.target.style.color = 'white';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.target.style.backgroundColor = 'transparent';
                                                                            e.target.style.color = 'black';
                                                                        }}
                                                                    >
                                                                        {meter.flow_meter_id} - {meter.flow_meter_name}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ padding: '10px', textAlign: 'center' }}>No results found</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Datetime
                                    value={fromDate ? new Date(fromDate) : null}
                                    onChange={(momentObj) => {
                                        if (momentObj.isValid()) {
                                            setFromDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                        }
                                    }}
                                    inputProps={{
                                        placeholder: "Select From Date Time",
                                        style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                    }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm"
                                    closeOnSelect={false}
                                />
                                <Datetime
                                    value={toDate ? new Date(toDate) : null}
                                    onChange={(momentObj) => {
                                        if (momentObj.isValid()) {
                                            if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                momentObj.set({
                                                    hour: 23,
                                                    minute: 59
                                                });
                                            }
                                            setToDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                        }
                                    }}
                                    inputProps={{
                                        placeholder: "Select To Date Time",
                                        style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                    }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat="HH:mm"
                                    closeOnSelect={false}
                                />
                                <button onClick={handleGetDailyReport}>Get Report</button>
                                <button onClick={() => {
                                    const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
                                    handleDailyExportToExcel(dailyreportData, fileName);
                                }}
                                >
                                    <i className="excel-icon">📊</i> Excel
                                </button>
                            </div>
                            {dailyloading ? (
                                <span className="spinner" />
                            ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Daily Log View from {fromDate ? moment(fromDate).format("YYYY-MM-DD HH:mm") : "Selected from Date"}
                                        to {toDate ? moment(toDate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>time</th>
                                                <th>Start Flow</th>
                                                <th>End Flow</th>
                                                <th>Total Flow</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentDailyRows.length > 0 ? (
                                                currentDailyRows.map((row) => (
                                                    <tr key={row.id}>
                                                        <td>{formatDateForDisplay(row.date)}</td>
                                                        <td>{row.timeRange}</td>
                                                        <td>{row.startLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.endLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{row.totalLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{totalDailyLiters.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unitType === 'kilo' ? 'KL' : 'ML'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                            <div className="pagination-controls">
                                <button
                                    disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                    onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                >
                                    Previous
                                </button>
                                <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                <button
                                    disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                    onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                    {activeTab === "Monthly" && (
                        <div className="Monthly-Report">
                            <div className="card controls-card">
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '-10px' }}>
                                    <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                                        <div style={{ flex: 1 }}>
                                            <div
                                                style={{
                                                    width: '95%',
                                                    padding: '8px',
                                                    borderRadius: '5px',
                                                    // border: '1px solid #ccc',
                                                    position: 'relative',
                                                    marginBottom: '10px'
                                                }}
                                            >
                                                <div ref={dropdownRef}>
                                                    <div
                                                        className="select-dropdown"
                                                        onClick={() => setIsOpen(!isOpen)}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <span>{selectedmonMeter ? filteredMonthlyMeter.find(meter => meter.flow_meter_id === selectedmonMeter)?.flow_meter_name : "Select Meter"}</span>
                                                        <span style={{ fontSize: '13px' }}><i className="fa-solid fa-angle-down"></i></span>
                                                    </div>

                                                    {isOpen && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '110%',
                                                                left: 0,
                                                                right: 0,
                                                                backgroundColor: 'white',
                                                                borderRadius: '5px',
                                                                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                                                                zIndex: 10,
                                                                maxHeight: '330px',
                                                                overflowY: 'auto',
                                                                border: '1px solid #000',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: '10px',
                                                                    borderBottom: '1px solid #ccc',
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Meter ID or Name"
                                                                    value={searchmonthMeter}
                                                                    onChange={(e) => setSearchmonthMeter(e.target.value)}
                                                                    style={{
                                                                        width: '95%',
                                                                        padding: '8px',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #ccc',
                                                                    }}
                                                                />
                                                            </div>
                                                            {filteredMonthlyMeter.length > 0 ? (
                                                                filteredMonthlyMeter.map((meter) => (
                                                                    <div
                                                                        key={meter.flow_meter_id}
                                                                        onClick={() => handleSelect(meter.flow_meter_id, 'Monthly')}
                                                                        style={{
                                                                            padding: '5px',
                                                                            cursor: 'pointer',
                                                                            textAlign: 'left',
                                                                            fontSize: '12px',
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.target.style.backgroundColor = '#006ec5';
                                                                            e.target.style.color = 'white';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.target.style.backgroundColor = 'transparent';
                                                                            e.target.style.color = 'black';
                                                                        }}
                                                                    >
                                                                        {meter.flow_meter_id} - {meter.flow_meter_name}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ padding: '10px' }}>No results found</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DatePicker
                                    selected={monthlyfromDate}
                                    onChange={handleMonthlyFromMonthChange}
                                    dateFormat="yyyy-MM"
                                    showMonthYearPicker
                                    placeholderText="Select From Month"
                                    className="custom-date-picker"
                                />

                                <DatePicker
                                    selected={monthlytoDate}
                                    onChange={handleMonthlyToMonthChange}
                                    dateFormat="yyyy-MM"
                                    showMonthYearPicker
                                    placeholderText="Select To Month"
                                    className="custom-date-picker"
                                />
                                <button onClick={fetchMonthlyReport}>Get Report</button>
                                <button onClick={handleMonthlyExportToExcel}>
                                    <i className="excel-icon">📊</i> Excel
                                </button>
                            </div>
                            {monthlyloading ? (
                                <div>
                                    <span className="spinner"></span>
                                </div>
                            ) : (
                                <div className="table-container">
                                    <h4 className="table-title">Monthly Report from {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected from Month"} to {monthlytoDate ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected to Month"}</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Month</th>
                                                <th>Start Flow</th>
                                                <th>End Flow</th>
                                                <th>Total Flow</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentMonthlyRows.length > 0 ? (
                                                currentMonthlyRows.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.id}</td>
                                                        <td>{item.month}</td>
                                                        <td>{item.startFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{item.endFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                        <td>{item.totalFlow.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{currentMonthlyRows.reduce((sum, row) => sum + row.totalFlow, 0).toLocaleString(undefined, { 
                                                    minimumFractionDigits: 2, 
                                                    maximumFractionDigits: 2 
                                                })} {reportData?.unit_type === 'kilo' ? 'KL' : 'ML'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                            <div className="pagination-controls">
                                <button
                                    disabled={currentmonthlyreportPage === 1 || currentMonthlyRows.length === 0}
                                    onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                >
                                    Previous
                                </button>
                                <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                <button
                                    disabled={currentmonthlyreportPage === totalmonthlyPages || currentMonthlyRows.length === 0}
                                    onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FlowReport;
